export default {
  index: [
    {
      path: '/PayTaxesMonthlyIndex',
      component: resolve => require(['./PayTaxesMonthlyIndex.vue'], resolve),
    },
    {
      path: '/TaxDeductionMonthlyIndex',
      component: resolve => require(['./TaxDeductionMonthlyIndex.vue'], resolve),
    },
    {
      path: '/TaxRateCalculationIndex',
      component: resolve => require(['./TaxRateCalculationIndex.vue'], resolve),
    },
    {
      path: '/TaxBurdenReportIndex',
      component: resolve => require(['./TaxBurdenReportIndex.vue'], resolve),
    },
    {
      path: '/VATCalculationsIndex',
      component: resolve => require(['./VATCalculationsIndex.vue'], resolve),
    },
  ]
}



// WEBPACK FOOTER //
// ./src/view/TaxStatements/_router.js